import { Injectable } from '@angular/core';
import { VernostServiceService } from './vernost-service.service';
import { Constants } from '../pages/master/test.constants';

@Injectable()
export class CsvUploadServiceInfo {
  csvRecords = [];
  fileImportInput: any;
  parent_table = "";
  constructor(private vernostService: VernostServiceService) { }

  fileChangeListen($event, parent_table): void {
    this.parent_table = parent_table;
    var target = $event.target || $event.srcElement;
    var files = target.files;
    var filename = files[0].name;
    var input = $event.target;
    var reader = new FileReader();
    reader.readAsText(input.files[0]);
    reader.onload = (data) => {
      var csvData: any;
      csvData = reader.result;
      var csvRecordsArray = csvData.split(/\r\n|\n/);
      var headerLength = -1;
      if (Constants.isHeaderPresentFlag) {
        var headersRow = this.vernostService.getHeaderArray(csvRecordsArray, Constants.tokenDelimeter);
        headerLength = headersRow.length;
      }

      this.csvRecords = this.vernostService.getDataRecordsArrayFromCSVFile(csvRecordsArray,
        headerLength, Constants.validateHeaderAndRecordLengthFlag, Constants.tokenDelimeter);
      var arr = {
        csvrecord: this.csvRecords,
        parent_table: this.parent_table,
        filename: filename
      }
      this.vernostService.insertCsvInformation(arr).subscribe(
        (response) => {
        });
    }

    reader.onerror = function () {
      alert('Unable to read ' + input.files[0]);
    };
  }
}
